import * as React from 'react';
import { Row, Col, Input, Tabs } from 'antd';
import { OfferingCardList } from '.';
import OfferingHandler from './OfferingHandler';
import { SlimOffering, OfferingType, IFilter, FilterType, JoinType } from 'Core/Api/Api';
import { STabCardDiv } from '../../Dashboard/DashboardView/DashboardView.Style';
import OfferingFilterBar from '../../Client/ClientIpoListView/ClientIpoListFilterBar';
import Search from 'antd/lib/input/Search';
import Title from 'antd/lib/typography/Title';
import TableRequest from '../../../Core/TableUtility/Models/TableRequest';
import { ChangeEvent } from 'react';
import { debounce } from 'lodash';
import { RouteComponentProps, withRouter } from 'react-router-dom';

const { TabPane } = Tabs;

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State {
    offerings?: SlimOffering[];
}

export class OfferingListViewWithoutRouter extends React.Component<Props, State> {
    handler: OfferingHandler;
    constructor(props: Props) {
        super(props);

        this.state = {};
        this.handler = new OfferingHandler(props);
    }

    componentDidMount() {

        this.getOffering();

    }

    getOffering() {
        this.handler.GetAllSlimOfferingsByFilter({}).then(x => {
            this.setState({ offerings: x.results })
        })
    }


    onChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.filterOffering(event.currentTarget.value);
    };

    filterOffering = debounce((text: any) => {
        var request = new TableRequest();
        if (text) {
            request.filters = [];
            request.filters?.push({
                value: text,
                filterType: FilterType.Contains,
                joinType: JoinType.Or,
                field: "title"
            });
        }
        this.handler.GetAllSlimOfferingsByFilter(request).then(x => {
            this.setState({ offerings: x.results })
        })
    }, 700);

    render() {
        return (
            <Row>
                <Col span={24} style={{ padding: '20px' }}>
                    <Row>
                        <Col>
                            <Title style={{ color: '#202020' }}>
                                Current IPO Offers
                            </Title>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16} offset={4}>
                            <Search
                                placeholder="Search for an IPO..."
                                onSearch={value => this.filterOffering(value)}
                                onChange={this.onChange}
                                style={{ marginBottom: '50px', marginTop: '50px', height: '60px', fontSize: '16px' }} />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <OfferingCardList offerings={this.state.offerings} {...this.props} />
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }
}


const OfferingListView = withRouter(OfferingListViewWithoutRouter);

export default OfferingListView;
